import styled from 'styled-components';

const InfoContainer = styled.div`
  color: var(--color-white);
  background: ${({ lightBg }) => (lightBg ? '#f9f9f9' : '#010606')};

  @media (max-width: 768px) {
    padding: 100px 0;
  }
`;

const InfoWrapper = styled.div`
  display: grid;
  justify-content: center;

  z-index: 1;
  height: 860px;
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
`;

const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  grid-column-gap: 1rem;
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col2 col1'` : `'col1 col2'`};

  @media (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

const ColumnOne = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

const ColumnTwo = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;

const TopLine = styled.p`
  color: var(--color-primary);
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 3rem;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? '#f7f8fa' : '#010606')};

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 3rem;
  font-size: 1rem;
  line-height: 24px;
  color: ${({ darkText }) => (darkText ? '#010606' : '#fff')};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const ImageWrapper = styled.figure`
  max-width: 400px;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  margin: 0 0 60px 0;
  padding-right: 0;
`;

export {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  ColumnOne,
  ColumnTwo,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ButtonWrapper,
  ImageWrapper,
  Image
};
